module.exports = __webpack_public_path__ + "static/img/logo.828c6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 353
// module chunks = 1